// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: SruSaz4XhKEy
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Button from "../../Button"; // plasmic-import: CLyiSGaOpklv/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicPermissionChip.module.css"; // plasmic-import: SruSaz4XhKEy/css

createPlasmicElementProxy;

export const PlasmicPermissionChip__VariantProps = new Array();

export const PlasmicPermissionChip__ArgProps = new Array("children");

const $$ = {};

function PlasmicPermissionChip__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"chipStack"}
        data-plasmic-override={overrides.chipStack}
        className={classNames(projectcss.all, sty.chipStack)}
      >
        <div
          data-plasmic-name={"chipText"}
          data-plasmic-override={overrides.chipText}
          className={classNames(projectcss.all, sty.chipText)}
        >
          {renderPlasmicSlot({
            defaultContents: "create invoice",
            value: args.children,
            className: classNames(sty.slotTargetChildren)
          })}
        </div>
        <Button
          data-plasmic-name={"clearChip"}
          data-plasmic-override={overrides.clearChip}
          className={classNames("__wab_instance", sty.clearChip)}
        >
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text
            )}
          >
            {"X"}
          </div>
        </Button>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "chipStack", "chipText", "clearChip", "text"],
  chipStack: ["chipStack", "chipText", "clearChip", "text"],
  chipText: ["chipText"],
  clearChip: ["clearChip", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPermissionChip__ArgProps,
          internalVariantPropNames: PlasmicPermissionChip__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPermissionChip__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPermissionChip";
  } else {
    func.displayName = `PlasmicPermissionChip.${nodeName}`;
  }
  return func;
}

export const PlasmicPermissionChip = Object.assign(
  // Top-level PlasmicPermissionChip renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    chipStack: makeNodeComponent("chipStack"),
    chipText: makeNodeComponent("chipText"),
    clearChip: makeNodeComponent("clearChip"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicPermissionChip
    internalVariantProps: PlasmicPermissionChip__VariantProps,
    internalArgProps: PlasmicPermissionChip__ArgProps
  }
);

export default PlasmicPermissionChip;
/* prettier-ignore-end */
